var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedinWhite = function SvgLinkedinWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,3C4.5,3,2,5.1,2,7.9c0,2.9,2.6,5,6,5c3.5,0,6-2.1,6-5.1C13.8,5,11.4,3,8,3z M3,15c-0.5,0-1,0.4-1,1v29 c0,0.5,0.5,1,1,1h10c0.6,0,1-0.5,1-1V16c0-0.6-0.4-1-1-1H3z M18,15c-0.5,0-1,0.4-1,1v29c0,0.5,0.5,1,1,1h9c0.6,0,1-0.4,1-1V30v-0.3 v-0.3c0-2.4,1.8-4.3,4.1-4.5c0.1,0,0.2,0,0.4,0s0.2,0,0.4,0c2.3,0.2,4.1,2.1,4.1,4.5V45c0,0.6,0.4,1,1,1h9c0.5,0,1-0.5,1-1V28 c0-6.5-3.5-13-11.2-13c-3.5,0-6.2,1.4-7.8,2.5V16c0-0.6-0.5-1-1-1H18z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedinWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Linkedin_white.8506236c.svg";
export { ForwardRef as ReactComponent };